import React from 'react';
import { motion } from 'framer-motion';
import { AnimatedSection } from './AnimatedSection';
import { AnimatedText } from './AnimatedText';
export function AboutSection() {
  const statVariants = {
    hidden: {
      opacity: 0,
      scale: 0.8
    },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section id="about" className="py-20 bg-white" data-id="element-20">
      <div className="container mx-auto px-4" data-id="element-21">
        <AnimatedSection className="text-center mb-16" data-id="element-22">
          <AnimatedText text="About Solochus Group" className="text-3xl md:text-4xl font-bold mb-4" as="h2" data-id="element-23" />
          <motion.p className="text-lg text-gray-600 max-w-2xl mx-auto" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7,
          delay: 0.3
        }} data-id="element-24">
            A leading conglomerate with a vision to transform industries through
            innovation, quality, and exceptional service.
          </motion.p>
        </AnimatedSection>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-16" data-id="element-25">
          <AnimatedSection delay={0.2} data-id="element-26">
            <h3 className="text-2xl font-bold text-blue-700 mb-4" data-id="element-27">Our Story</h3>
            <p className="text-gray-700 mb-4" data-id="element-28">
              Founded in 2005, Solochus Group began with a single hospitality
              venture and has since grown into a diversified conglomerate with
              interests across multiple sectors.
            </p>
            <p className="text-gray-700 mb-4" data-id="element-29">
              Our journey has been marked by a commitment to excellence,
              strategic growth, and the development of businesses that add value
              to the communities we serve.
            </p>
            <p className="text-gray-700" data-id="element-30">
              Today, we continue to expand our portfolio while maintaining the
              core values that have driven our success: integrity, innovation,
              and a customer-first approach.
            </p>
          </AnimatedSection>
          <AnimatedSection delay={0.4} data-id="element-31">
            <div className="relative rounded-lg overflow-hidden shadow-xl" data-id="element-32">
              <img src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" alt="Solochus Group Headquarters" className="w-full h-auto" data-id="element-33" />
              <div className="absolute inset-0 bg-blue-900/20" data-id="element-34"></div>
            </div>
          </AnimatedSection>
        </div>
        <AnimatedSection delay={0.3} data-id="element-35">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-id="element-36">
            <motion.div className="bg-blue-50 p-6 rounded-lg text-center" variants={statVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} custom={0} data-id="element-37">
              <motion.div className="text-4xl font-bold text-blue-700 mb-2" initial={{
              opacity: 0,
              y: -20
            }} whileInView={{
              opacity: 1,
              y: 0,
              transition: {
                duration: 0.5,
                delay: 0.3
              }
            }} viewport={{
              once: true
            }} data-id="element-38">
                15+
              </motion.div>
              <h3 className="text-xl font-medium text-gray-800" data-id="element-39">
                Years of Excellence
              </h3>
            </motion.div>
            <motion.div className="bg-blue-50 p-6 rounded-lg text-center" variants={statVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} custom={1} data-id="element-40">
              <motion.div className="text-4xl font-bold text-blue-700 mb-2" initial={{
              opacity: 0,
              y: -20
            }} whileInView={{
              opacity: 1,
              y: 0,
              transition: {
                duration: 0.5,
                delay: 0.4
              }
            }} viewport={{
              once: true
            }} data-id="element-41">
                4
              </motion.div>
              <h3 className="text-xl font-medium text-gray-800" data-id="element-42">
                Business Verticals
              </h3>
            </motion.div>
            <motion.div className="bg-blue-50 p-6 rounded-lg text-center" variants={statVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} custom={2} data-id="element-43">
              <motion.div className="text-4xl font-bold text-blue-700 mb-2" initial={{
              opacity: 0,
              y: -20
            }} whileInView={{
              opacity: 1,
              y: 0,
              transition: {
                duration: 0.5,
                delay: 0.5
              }
            }} viewport={{
              once: true
            }} data-id="element-44">
                500+
              </motion.div>
              <h3 className="text-xl font-medium text-gray-800" data-id="element-45">Employees</h3>
            </motion.div>
            <motion.div className="bg-blue-50 p-6 rounded-lg text-center" variants={statVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} custom={3} data-id="element-46">
              <motion.div className="text-4xl font-bold text-blue-700 mb-2" initial={{
              opacity: 0,
              y: -20
            }} whileInView={{
              opacity: 1,
              y: 0,
              transition: {
                duration: 0.5,
                delay: 0.6
              }
            }} viewport={{
              once: true
            }} data-id="element-47">
                3
              </motion.div>
              <h3 className="text-xl font-medium text-gray-800" data-id="element-48">
                Cities Served
              </h3>
            </motion.div>
          </div>
        </AnimatedSection>
        <AnimatedSection delay={0.4} data-id="element-49">
          <div className="bg-blue-700 rounded-lg p-8 text-white" data-id="element-50">
            <div className="max-w-3xl mx-auto text-center" data-id="element-51">
              <h3 className="text-2xl font-bold mb-4" data-id="element-52">Our Vision</h3>
              <p className="text-lg mb-8" data-id="element-53">
                To be the leading conglomerate that transforms industries
                through innovation, quality, and exceptional service, creating
                lasting value for our customers, employees, and communities.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-54">
                <div className="bg-blue-800/50 p-4 rounded-lg" data-id="element-55">
                  <h4 className="font-bold text-xl mb-2" data-id="element-56">Integrity</h4>
                  <p data-id="element-57">
                    We conduct business with honesty, transparency, and ethical
                    standards.
                  </p>
                </div>
                <div className="bg-blue-800/50 p-4 rounded-lg" data-id="element-58">
                  <h4 className="font-bold text-xl mb-2" data-id="element-59">Excellence</h4>
                  <p data-id="element-60">
                    We strive for excellence in everything we do, setting high
                    standards across all our businesses.
                  </p>
                </div>
                <div className="bg-blue-800/50 p-4 rounded-lg" data-id="element-61">
                  <h4 className="font-bold text-xl mb-2" data-id="element-62">Innovation</h4>
                  <p data-id="element-63">
                    We embrace innovation to drive growth, efficiency, and
                    improved customer experiences.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </AnimatedSection>
      </div>
    </section>;
}